module.exports = __webpack_public_path__ + "img/slide7.fb4137d6.png";